import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaicab() {



const cardData = {
  keyword: " Pune to Mumbai Cab",

"headingDescription": "Pune to Mumbai Cab service offers a reliable, comfortable, and hassle-free travel experience for passengers commuting between Pune and Mumbai. Whether it’s airport transfers, business travel, family trips, or weekend getaways, our professional drivers and well-maintained vehicles ensure a smooth journey. We provide one-way rides, round trips, and customized travel plans with transparent pricing and no hidden charges. With SRS Pune to Mumbai Cab, enjoy easy online booking, 24/7 customer support, and a convenient ride across Maharashtra.",
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Gateway of India is one of Mumbai’s most iconic landmarks located near the Arabian Sea. Travelers booking Pune to Mumbai Cab often visit this historic monument to enjoy sea views and capture memorable photos."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, offers a beautiful seaside promenade. Visitors using Pune to Mumbai Cab enjoy evening walks and stunning sunset views along this famous stretch."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves are ancient rock-cut caves dedicated to Lord Shiva, located on an island near Mumbai. Travelers using Pune to Mumbai Cab can explore these UNESCO-listed caves for history and architecture."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple is a famous temple dedicated to Lord Ganesha. Devotees traveling via Pune to Mumbai Cab visit this temple to seek blessings and experience its spiritual atmosphere."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular beaches known for street food and sunset views. Visitors booking Pune to Mumbai Cab often relax here and enjoy local snacks like pav bhaji and bhel puri."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a renowned religious site located on a small island in the sea. Travelers using Pune to Mumbai Cab visit this place for its spiritual significance and unique location."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description": "Chhatrapati Shivaji Maharaj Terminus is a UNESCO World Heritage Site known for its Victorian Gothic architecture. Visitors traveling via Pune to Mumbai Cab admire this historic railway station."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "Bandra-Worli Sea Link is a modern engineering marvel connecting key parts of Mumbai. Passengers using Pune to Mumbai Cab enjoy driving across this bridge with scenic sea views."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a popular shopping street known for fashion items and street shopping. Travelers booking Pune to Mumbai Cab often explore this area for shopping and local experiences."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a vast green space in Mumbai offering wildlife, nature trails, and Kanheri Caves. Visitors using Pune to Mumbai Cab enjoy this destination for a refreshing escape from city life."
  }
],



services: [
{
name: "Pune to Mumbai Cab Service",
description: "Pune to Mumbai cab service offers reliable intercity travel via the Mumbai–Pune Expressway. Customers can book comfortable vehicles for business, airport, or leisure trips. Professional drivers ensure safe and timely journeys. One-way and round trip options are available for flexibility. Transparent pricing ensures affordable fares. Travel conveniently between Pune and Mumbai with trusted cab services."
},
{
name: "Affordable Cabs Pune to Mumbai",
description: "Affordable cabs Pune to Mumbai provide budget-friendly travel options for passengers. Customers can choose economical vehicles for cost-effective journeys. Professional drivers ensure smooth and safe travel. One-way cab options help reduce travel expenses. Transparent pricing ensures no hidden charges. Travel affordably between Pune and Mumbai with reliable cab services."
},
{
name: "Luxury Cabs Pune to Mumbai",
description: "Luxury cabs Pune to Mumbai offer premium travel experience with high-end vehicles. Customers can enjoy comfortable seating and smooth highway journeys. Professional chauffeurs ensure safe and stylish travel. Ideal for corporate and VIP travel needs. Flexible booking options are available. Experience luxury travel between Pune and Mumbai with top cab services."
},
{
name: "Pune to Mumbai Cheapest Cab",
description: "Pune to Mumbai cheapest cab service provides economical travel options for budget travelers. Customers can book low-cost vehicles without compromising safety. Professional drivers ensure smooth journeys via expressway. One-way options reduce overall travel cost. Transparent pricing ensures affordability. Travel cost-effectively between Pune and Mumbai with cheapest cab services."
},
{
name: "Pune Mumbai Taxi Service",
description: "Pune Mumbai taxi service offers dependable transportation between the two cities. Customers can book taxis for business trips, airport transfers, and family travel. Professional drivers ensure timely and safe journeys. Multiple vehicle options suit different needs. Transparent pricing ensures fair fares. Enjoy smooth taxi travel between Pune and Mumbai."
},
{
name: "Pune to Mumbai Airport Cabs",
description: "Pune to Mumbai airport cabs provide direct transportation to Mumbai Airport terminals. Customers can book rides for timely airport drop and pickup. Professional drivers ensure punctual service for flights. Comfortable vehicles ensure smooth journeys. Transparent pricing ensures affordability. Travel stress-free to Mumbai Airport from Pune with cab services."
},
{
name: "Pune to Mumbai Outstation Cabs",
description: "Pune to Mumbai outstation cabs offer reliable long-distance travel with flexible booking options. Customers can choose one-way or round trip packages. Comfortable vehicles ensure smooth expressway journeys. Professional drivers ensure safe travel. Transparent pricing makes it budget-friendly. Choose outstation cab services for Pune to Mumbai travel."
},
{
name: "Pune to Mumbai Cab Booking Online",
description: "Pune to Mumbai cab booking online provides quick and easy reservation options. Customers can book taxis instantly through digital platforms. Professional drivers ensure safe and timely travel. Multiple vehicle options suit different budgets. Transparent pricing ensures fair fares. Book your Pune to Mumbai cab online for convenience."
},
{
name: "Pune Mumbai Express Taxi",
description: "Pune Mumbai express taxi service offers fast and efficient travel via expressway routes. Customers can enjoy quick transit between the two cities. Professional drivers ensure smooth and safe journeys. Comfortable vehicles enhance travel experience. Affordable pricing ensures value for money. Choose express taxi services for Pune to Mumbai travel."
},
{
name: "Pune to Mumbai Private Cabs",
description: "Pune to Mumbai private cabs provide personalized travel experience for individuals and families. Customers can enjoy private rides without sharing. Comfortable vehicles ensure smooth journeys. Professional drivers ensure safety and punctuality. Flexible booking options are available. Travel privately between Pune and Mumbai with trusted cab services."
},
{
name: "Pune Mumbai One-Way Taxi",
description: "Pune Mumbai one-way taxi service offers cost-effective travel without return charges. Customers can book direct one-way rides easily. Professional drivers ensure safe and timely journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Choose one-way taxi services for Pune to Mumbai travel."
},
{
name: "Pune to Mumbai Round Trip Cabs",
description: "Pune to Mumbai round trip cabs provide convenient two-way travel options. Customers can plan return journeys with flexible schedules. Comfortable vehicles ensure smooth highway travel. Professional drivers ensure safe journeys. Transparent pricing ensures budget-friendly travel. Book round trip cabs for Pune to Mumbai trips."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai airport cab service offers reliable transportation to airport terminals. Customers can book taxis for timely drop services. Professional drivers ensure punctual arrivals for flights. Comfortable vehicles ensure smooth journeys. Transparent pricing ensures affordability. Travel easily from Pune to Mumbai Airport with cab services."
},
{
name: "Pune to Mumbai Taxi",
description: "Pune to Mumbai taxi service provides convenient intercity transportation for all travelers. Customers can book taxis for business or leisure trips. Professional drivers ensure safe and timely journeys. Multiple vehicle options are available. Transparent pricing ensures fair fares. Enjoy smooth taxi travel between Pune and Mumbai."
},
{
name: "Pune to Mumbai Airport Cab Fare",
description: "Pune to Mumbai airport cab fare service offers transparent pricing for airport transfers. Customers can check fare details before booking. Affordable rates ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Choose cab services with clear pricing for Pune to Mumbai airport travel."
},
{
name: "Pune Mumbai Airport Drop",
description: "Pune Mumbai airport drop service provides direct transportation to airport terminals. Customers can book cabs for timely drop-offs. Professional drivers ensure punctual arrivals. Comfortable vehicles ensure smooth travel. Transparent pricing ensures affordability. Enjoy hassle-free airport drop services from Pune to Mumbai."
},
{
name: "Best Cab Service Pune to Mumbai",
description: "Best cab service Pune to Mumbai offers top-quality travel experience with reliable vehicles. Customers can enjoy smooth journeys with professional drivers. Ideal for business and personal travel. Transparent pricing ensures value for money. Flexible booking options add convenience. Choose the best cab service for Pune to Mumbai travel."
},
{
name: "Pune to Mumbai Cab Fare",
description: "Pune to Mumbai cab fare service provides clear pricing for intercity travel. Customers can check fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Choose cab services with transparent fare for Pune to Mumbai travel."
},
{
name: "Pune Mumbai Taxi Service",
description: "Pune Mumbai taxi service offers reliable transportation between the two cities. Customers can book taxis for local and airport travel. Professional drivers ensure safe and timely journeys. Comfortable vehicles enhance travel comfort. Transparent pricing ensures fair fares. Enjoy smooth taxi services between Pune and Mumbai."
},
{
name: "Pune to Mumbai Car",
description: "Pune to Mumbai car service provides private vehicle options for intercity travel. Customers can choose from sedan and SUV vehicles. Professional drivers ensure safe and smooth journeys. Flexible booking options are available. Transparent pricing ensures affordability. Travel comfortably between Pune and Mumbai with car services."
},
{
name: "Pune Mumbai Taxi Fare",
description: "Pune Mumbai taxi fare service offers clear pricing details for travelers. Customers can estimate travel costs easily. Affordable rates ensure budget-friendly journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Choose taxi services with transparent fares for Pune to Mumbai travel."
},
{
name: "Pune to Mumbai International Airport Cab",
description: "Pune to Mumbai international airport cab service offers direct travel to international terminals. Customers can book taxis for timely airport transfers. Professional drivers ensure punctual arrivals. Comfortable vehicles ensure smooth journeys. Transparent pricing ensures affordability. Travel stress-free to Mumbai International Airport from Pune."
},
{
name: "Pune to Mumbai Cab Price",
description: "Pune to Mumbai cab price service provides clear and competitive pricing for intercity travel. Customers can compare rates before booking. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent pricing for Pune to Mumbai."
},
{
name: "Pune to Mumbai Airport Cab Price",
description: "Pune to Mumbai airport cab price service offers detailed pricing for airport travel. Customers can check fare before booking rides. Affordable rates ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent pricing for airport transfers."
}
],

tableData: [
["Pune to Mumbai Cab Service","Affordable Cabs Pune to Mumbai"],
["Luxury Cabs Pune to Mumbai","Pune to Mumbai Cheapest Cab"],
["Pune Mumbai Taxi Service","Pune to Mumbai Airport Cabs"],
["Pune to Mumbai Outstation Cabs","Pune to Mumbai Cab Booking Online"],
["Pune Mumbai Express Taxi","Pune to Mumbai Private Cabs"],
["Pune Mumbai One-Way Taxi","Pune to Mumbai Round Trip Cabs"],
["Pune to Mumbai Airport Cab","Pune to Mumbai Taxi"],
["Pune to Mumbai Airport Cab Fare","Pune Mumbai Airport Drop"],
["Best Cab Service Pune to Mumbai","Pune to Mumbai Cab Fare"],
["Pune Mumbai Taxi Service","Pune to Mumbai Car"],
["Pune Mumbai Taxi Fare","Pune to Mumbai International Airport Cab"],
["Pune to Mumbai Cab Price","Pune to Mumbai Airport Cab Price"]
],





whychoose: [
  {
    WhyChooseheading: "Expert Mumbai-Pune Expressway Drivers",
    WhyChoosedescription: "SRS Cab Service provides experienced drivers who frequently travel on the Mumbai-Pune Expressway, ensuring safe driving, smooth navigation, and timely travel between Pune and Mumbai."
  },
  {
    WhyChooseheading: "Affordable Pune to Mumbai Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Mumbai cab services with transparent pricing. Customers receive complete fare details including tolls and driver allowance with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates round the clock for Pune to Mumbai cab bookings, making it easy to plan early morning airport drops, business trips, or late-night travel."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All our vehicles are well-maintained, air-conditioned, and regularly sanitized to provide a comfortable and relaxing journey from Pune to Mumbai."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We offer flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Pune to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for all travel needs."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide easy pickup from homes, hotels, offices, and Pune Airport across all areas including Hinjewadi, Wakad, Baner, Kharadi, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Mumbai cab bookings due to punctual drivers, reliable vehicles, and professional service for intercity travel."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Mumbai cab service?", answer: "Yes, SRS Cab Service offers reliable Pune to Mumbai cab service with professional drivers and comfortable vehicles." },
  { question: "How far is Pune from Mumbai?", answer: "The distance between Pune and Mumbai is approximately 150 km and the journey takes around 3 to 4 hours depending on traffic." },
  { question: "Is Pune to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for Pune to Mumbai travel." },
  { question: "Which vehicles are available for Pune to Mumbai travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pune to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Do you provide pickup from home in Pune?", answer: "Yes, we offer doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Mumbai cab service online or via phone." },
  { question: "Do you provide drop service to Mumbai Airport?", answer: "Yes, we provide drop services to Mumbai Airport, railway stations, and major locations in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Patil",
    feedback:
      "Booked SRS Cab Service from Pune to Mumbai. Smooth journey on expressway and very professional driver.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Gupta",
    feedback:
      "Reliable Pune to Mumbai cab service. Clean car, on-time pickup, and very comfortable ride.",
    rating: 5
  }
];



































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];















const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Cab | SRS Cab",
  "description": "SRS Cab provides Pune to Mumbai cab services including affordable, luxury, and express cabs. Book Pune to Mumbai airport transfers, one-way trips, round trips, private cabs, and outstation services online. Enjoy safe, comfortable, and punctual rides with 24x7 booking from Pune to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};



  return (
    <div>
      
<Helmet>
  <title>Pune to Mumbai Cab | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai cabs with SRS Cab. Affordable, luxury, express, one-way & round trip cabs. Pune to Mumbai Airport, private cabs, and outstation services with 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaicab;